import { render, staticRenderFns } from "./tminfo.vue?vue&type=template&id=ffbaa3ce&scoped=true&"
import script from "./tminfo.vue?vue&type=script&lang=js&"
export * from "./tminfo.vue?vue&type=script&lang=js&"
import style0 from "./tminfo.vue?vue&type=style&index=0&id=ffbaa3ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbaa3ce",
  null
  
)

export default component.exports